<div class="innerpage-fullwithbanner" *ngIf="!viewAsChild && !Authentication.Broker()">
    <h2 class="bighead" *ngIf="currentMenu !='Sell'">Offers</h2>
    <h2 class="bighead" *ngIf="currentMenu =='Sell'">My Deals</h2>
    <ul class="bread-crumbs cf">
        <!--{{selectedList == propertyFor.Sale ? 'Sale' :'1031 Trade'}}-->
        <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
        <li *ngIf="currentMenu!='' && currentMenu !='Sell'"><span>{{currentMenu}}<span style="padding:8px;">|</span></span></li>
        <li *ngIf="activeview === view.Likes || activeview === view.Views"><a (click)="onBack(view.DealList);">Deals List<span>|</span></a></li>
        <li>{{subPageName}}</li>
    </ul>

</div>
<div class="featuredproperties section-margin">
    <div class="container container-lg min-heightcontainer">
        <div class="row" [hidden]="activeview !== view.DealList">
            <div class="col-lg-12 ">
              <div class="border-div table-fixed  margin-bottom-0">
                <div class="floatinghead clearfix">
                  <h2 class="mainhead " *ngIf="Authentication.Broker()"><span class="text">Offers - Sell</span></h2>
                  <!--<h2 class="mainhead "><span class="text">Deals</span></h2>-->
                  <div class="rightside clearfix">

                    <div class="search-sec">
                      <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                      <i class="fa fa-search icon" aria-hidden="true"></i>
                    </div>
                    <!--<a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);" tooltip="Add Registered User" placement="left" (click)="addPrincipal()"><i class="fa fa-plus icon" aria-hidden="true"></i></a>-->
                  </div>
                </div>
                <div class="floatinghead be-tab-02 clearfix">
                  <ul class="nav nav-tabs">
                    <li class="nav-item">
                      <a [class.active]="selectedSubTab == 1" href="javascript:void(0);" (click)="ArchiveTab(1);" class="nav-link active">
                        Active
                      </a>
                    </li>
                    <li class="nav-item">
                      <a [class.active]="selectedSubTab == 2" href="javascript:void(0);" (click)="ArchiveTab(2);" class="nav-link">
                        Inactive
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="table-responsive">
                  <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                    <thead>
                      <tr>
                        <th class="min-width-td sticky-left z-100">Tenant</th>
                        <th style="width:100px">State</th>
                        <th style="width:100px">City</th>
                        <th style="width:100px">Asking Price</th>
                        <th style="width:100px">Best Offer</th>
                        <th style="width:100px">Recent Offer</th>
                        <!--[hidden]="Is1031"-->
                        <th [hidden]="Authentication.Seller()" style="width:60px">Sales Offers</th>
                        <!--[hidden]="!Is1031"-->
                        <th [hidden]="Authentication.Seller()" style="width:60px">1031 Offers</th>
                        <th style="width:60px">Likes</th>
                        <th style="width:60px">Views</th>
                        <th [hidden]="Is1031" style="width:60px">Inquiries</th>
                        <th style="width:60px">OM Requests</th>
                        <th style="width:60px">Listing Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let Deals of SalesDealsList;let i = index ">
                        <td class="sticky-left">
                          <p><a href="javascript:void(0);" routerLink="/viewproperty/{{Deals.Slug ? Deals.Slug :Deals.PropertyGuid}}" [queryParams]="{prevroute:pageName,link:router.url}">{{ Deals.PropertyName }}</a></p>
                          <!--<p>{{Deals.BuildingSize ? (Deals.BuildingSize|number) +' SF':'-' }}<span> | </span>{{Deals.Address ? Deals.Address:'-' }}</p>-->
                        </td>
                        <td>
                          <p *ngIf="haveaccesstoviewlocation">{{Deals.State ? Deals.State:'-' }}</p>
                          <p *ngIf="!haveaccesstoviewlocation">{{Deals.ConfidentialLocation ? 'Confidential': Deals.State ? Deals.State:'-' }}</p>
                        </td>
                        <td>
                          <p *ngIf="haveaccesstoviewlocation">{{Deals.Address ? Deals.Address:'-' }}</p>
                          <p *ngIf="!haveaccesstoviewlocation">{{Deals.ConfidentialLocation ? 'Confidential': Deals.Address ? Deals.Address:'-' }}</p>
                        </td>
                        <td>
                          <p *ngIf="Deals.Unpriced" class="whitespacenowrap">Unpriced</p>
                          <p *ngIf="!Deals.Unpriced" class="whitespacenowrap">{{(Deals.AskingPrice!=null&&Deals.AskingPrice>=0) ? '$'+ (Deals.AskingPrice|number) :'-'}}</p>
                        </td>
                        <td><p class="whitespacenowrap">{{(Deals.BestOffer!=null&&Deals.BestOffer>=0) ? '$'+ (Deals.BestOffer|number) :'-'}}</p></td>
                        <td><p class="whitespacenowrap">{{(Deals.RecentOffer!=null&&Deals.RecentOffer>=0) ? '$'+ (Deals.RecentOffer|number) :'-'}}</p></td>
                        <td [hidden]="Authentication.Seller()">
                          <p *ngIf="Deals.Offers"><a href="javascript:void(0);" (click)="onViewSelect(view.Offers,Deals.PropertyGuid);">{{Deals.Offers|number}}</a></p>
                          <p *ngIf="!Deals.Offers">-</p>
                        </td>
                        <td [hidden]="Authentication.Seller()">
                          <p *ngIf="(Deals.Offers1031!=null&&Deals.Offers1031>=0)"><a href="javascript:void(0);" (click)="onViewSelect(view.Offers,Deals.PropertyGuid);">{{Deals.Offers1031|number}}</a></p>
                          <p *ngIf="(Deals.Offers1031==null||Deals.Offers1031)">-</p>
                        </td>
                        <td>
                          <p *ngIf="(Deals.Likes!=null&&Deals.Likes>=0)"><a href="javascript:void(0);" (click)="onViewSelect(view.Likes,Deals.PropertyGuid);">{{Deals.Likes|number}}</a></p>
                          <p *ngIf="(Deals.Likes==null||Deals.Likes<0)">-</p>
                        </td>
                        <td>
                          <p *ngIf="(Deals.Views!=null&&Deals.Views>=0)"><a href="javascript:void(0);" (click)="onViewSelect(view.Views,Deals.PropertyGuid);">{{Deals.Views|number}}</a></p>
                          <p *ngIf="(Deals.Views==null||Deals.Views<0)">-</p>
                        </td>
                        <td [hidden]="Is1031">
                          <p *ngIf="(Deals.Inquiries!=null&&Deals.Inquiries>=0)"><a href="javascript:void(0);" (click)="onViewSelect(view.Inquiries,Deals.PropertyGuid);">{{Deals.Inquiries|number}}</a></p>
                          <p *ngIf="(Deals.Inquiries==null||Deals.Inquiries<0)">-</p>
                        </td>
                        <td>
                          <p *ngIf="(Deals.OM!=null&&Deals.OM>=0)"><a href="javascript:void(0);" (click)="onViewSelect(view.OM,Deals.PropertyGuid);">{{Deals.OM|number}}</a></p>
                          <p *ngIf="(Deals.OM==null||Deals.OM<0)">-</p>
                        </td>
                        <td>
                          <p>{{Deals.PropertyFor == 601 ? 'B+E Listing' : '1031 Exchange'}}</p>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr *ngIf="SalesDealsList?.length == 0 &&!IsLoading">
                        <td colspan="12" class="odd no-data-available">
                          <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Data Available</p>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
        </div>
    </div>
</div>
